import React from "react";
import { useTranslation } from "react-i18next";

export default function StickyCTA({ onClick }) {
  const { t } = useTranslation();

  return (
    <>
      {/* DESKTOP floating card */}
      <div className="hidden md:flex fixed bottom-6 right-6 z-40">
        <div className="bg-background-light dark:bg-background-dark border border-gray-200 dark:border-gray-800 shadow-xl rounded-2xl p-5 w-72 space-y-3">
          <h3 className="font-semibold text-base">
            {t("cta_title")}
          </h3>

          <p className="text-sm text-text-light/70 dark:text-text-dark/70">
            {t("cta_subtitle")}
          </p>

          <button
            onClick={onClick}
            className="w-full bg-primary-light dark:bg-primary-dark text-white dark:text-black py-2 rounded-lg hover:opacity-90 text-sm font-medium"
          >
            {t("cta_button")}
          </button>
        </div>
      </div>

      {/* MOBILE bottom bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-light dark:bg-background-dark border-t border-gray-200 dark:border-gray-800 p-3">
        <button
          onClick={onClick}
          className="w-full bg-primary-light dark:bg-primary-dark text-white dark:text-black py-3 rounded-xl font-medium"
        >
          {t("cta_button")}
        </button>
      </div>
    </>
  );
}